<template>
  <div class="content">
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-md-4">
          <div class="label" :style="FormErrors.name && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.name") }}
          </div>
          <div class="input-group mb-3">
            <input @change="toggleChange = !toggleChange" v-model="formData['name']" type="text"
              class="input-style input-padding" maxlength="100" :style="FormErrors.name && saveClicked
                  ? 'border-color: red !important'
                  : ''
                " />
          </div>
        </div>
        <div class="col-md-4">
          <div class="label" :style="FormErrors.externalId && saveClicked
              ? 'color: red !important'
              : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.code") }}
          </div>
          <div class="input-group mb-3">
            <input @change="toggleChange = !toggleChange" v-model="formData['externalId']" type="text"
              class="input-style input-padding" :class="pageFrom == 'edit' ? 'disabled' : ''"
              :disabled="pageFrom == 'edit'" maxlength="30" :style="FormErrors.externalId && saveClicked
                  ? 'border-color: red !important'
                  : ''
                " />
            <ul v-if="formData['externalId'].length > 12" style="color: red">
              <li>{{ $t("pages.Client.projectCodeLengthError") }}</li>
            </ul>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label" :style="FormErrors.keycloak && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.keycloak") }}
          </div>
          <div class="input-group mb-3">
            <input @change="toggleChange = !toggleChange" v-model="formData['keycloak']" type="text"
              class="input-style input-padding" maxlength="30" :class="pageFrom == 'edit' ? 'disabled' : ''"
              :disabled="pageFrom == 'edit'" :style="FormErrors.keycloak && saveClicked
                  ? 'border-color: red !important'
                  : ''
                " />
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Status dropdown list -->
        <div class="col-md-4">
          <div class="label" :style="FormErrors.status && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.status") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
  :key="$i18n.locale"
  v-model="formData.status"
  :itemsSource="translatedStatus"
  :selectedValuePath="'id'"
  :displayMemberPath="'translatedLabel'"
  class="input-style"
  :isRequired="false"
  @change="toggleChange = !toggleChange"
        :style="FormErrors.status && saveClicked
                  ? 'border-color: red !important'
                  : ''"
/>
          </div>
        </div>
        <!-- END Status dropdown list -->
        <div class="col-md-4">
          <div class="label" :style="FormErrors.timeZone && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.timeZone") }}
          </div>
          <div class="input-group mb-3">
            <wj-auto-complete @change="toggleChange = !toggleChange" class="input-style" id="theAutoComplete"
              :itemsSource="timeZones" :selectedValuePath="'id'" :displayMemberPath="'name'" :isRequired="false"
              v-model="formData['timezone']" :style="FormErrors.timeZone && saveClicked
                  ? 'border-color: red !important'
                  : ''
                ">
            </wj-auto-complete>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label" :style="FormErrors.culture && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.culture") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box @change="toggleChange = !toggleChange" class="input-style" :itemsSource="translatedCultures"
              :selectedValuePath="'code'" :displayMemberPath="'translatedDescription'" :isRequired="false"
              v-model="formData['culture']" :style="FormErrors.culture && saveClicked
                  ? 'border-color: red !important'
                  : ''
                ">
            </wj-combo-box>
          </div>
        </div>
      </div>
      <!-- third line -->
      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.forbiddenBusinessActs") }}
          </div>
          <div class="input-group mb-3">
            <wj-multi-select :headerFormat="`{count:n0} ${$t(
              'pages.Client.forbiddenBusinessActs'
            )}`" :itemsSource="businessActs" :displayMemberPath="'display'" :selectedValuePath="'businessAct'"
              :checkedItems="businessActs.filter((ba) => isSelectedItem(formData, ba))
                " class="input-style" :checkedItemsChanged="onForbiddenBusinessActChanged"></wj-multi-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label" :style="FormErrors.gdpr && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.rgpd") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box
  :key="$i18n.locale"
  v-model="formData.gdpr"
  :itemsSource="translatedRgpd"
  :selectedValuePath="'id'"
  :displayMemberPath="'translatedLabel'"
  class="input-style"
  :isRequired="false"
  @change="toggleChange = !toggleChange"
      :style="FormErrors.gdpr && saveClicked
                  ? 'border-color: red !important'
                  : ''
                "
/>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label" :style="FormErrors.apiCurve && saveClicked ? 'color: red !important' : ''
            ">
            <span class="red-alarm">*</span> {{ $t("pages.Client.apiCurve") }}
          </div>
          <div class="input-group mb-3">
            <wj-combo-box @change="toggleChange = !toggleChange" class="input-style" :itemsSource="translatedApiCurves"
              :selectedValuePath="'externalId'" :displayMemberPath="'translatedDescription'" :isRequired="false"
              v-model="formData['apiCurve']" :style="FormErrors.apiCurve && saveClicked
                  ? 'border-color: red !important'
                  : ''
                ">
            </wj-combo-box>
          </div>
        </div>
      </div>
      <!-- fourth line -->
      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.daysNumber") }}
          </div>
          <div class="input-group mb-3">
            <input @change="toggleChange = !toggleChange" v-model="formData['daysNumber']" type="number"
              class="input-style input-padding" min="1" />
          </div>
        </div>
        <!-- levels zone -->
        <div class="col-md-4">
          <div class="label" :style="FormErrors.levelsNumber && saveClicked
              ? 'color: red !important'
              : ''
            ">
            <span class="red-alarm">*</span>
            {{ $t("pages.Client.levelsNumber") }}
          </div>
          <div class="input-group mb-3">
            <input @change="toggleChange = !toggleChange" v-model="formData['levelsNumber']" type="number"
              class="input-style input-padding input-auto-width" min="1" max="65165" :style="FormErrors.levelsNumber && saveClicked
                  ? 'border-color: red !important'
                  : ''
                " />
          </div>
        </div>
        <!-- end levels zone -->
        <div class="col-md-2">
          <div class="label">
            <br />
          </div>
          <div class="input-group mb-3">
            <a class="dm-a-default" :style="formData.levelsNumber > 0 ? '' : notClickable" @click.prevent="
              formData.levelsNumber > 0
                ? (showModal = true)
                : (showModal = false)
              ">
              <i class="scf-edit"></i> {{ $t("pages.Client.enteringZones") }}
            </a>
            <formModalZones :show="showModal" :title="zoneModalTitle" :type="'notif'"
              :nbZones="formData['levelsNumber']" :initialLevels="formData.levels" :key="formData.externalId"
              :fromPage="pageFrom" @update:show="updateModal">
            </formModalZones>
          </div>
        </div>

        <!-- put my component here -------------------------------------------------------------------------------------------------->
        <div class="col-md-2">
          <div class="label">
            <br />
          </div>
          <div class="input-group mb-3">
            <a class="dm-a-default"
              :style="(formData.status != 'Inactive' && formData.levelsNumber > 0 && formData.levels.filter(val => this.isValid(val))).length == formData.levelsNumber ? '' : notClickable"
              @click.prevent="
                (formData.status != 'Inactive' && formData.levelsNumber > 0 && formData.levels.filter(val => this.isValid(val)).length == formData.levelsNumber)
                  ? (showModalOrg = true)
                  : (showModalOrg = false)
                ">
              <i class="scf-edit"></i> {{ $t("pages.Client.ManagmentOfHirarchicalLevels") }}
            </a>
            <formModalOrganizations :show="showModalOrg" :title="$t('pages.Client.HierarchicalLevelManagement')"
              :type="'notif'" :nbZones="formData['levelsNumber']" :levels="formData.levels"
              :client="formData['externalId']" :key="61" :fromPage="pageFrom"
              :hierarchyItem="this.formData.hierarchyContent" @update:show="UpdateHirarchicalConfig">
            </formModalOrganizations>
          </div>
        </div>
        <!-- end put my component here  -------------------------------------------------------------------------------------------------->
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.comment") }}
          </div>
          <div class="input-group mb-3">
            <textarea @change="toggleChange = !toggleChange" v-model="formData['comment']" maxlength="400"
              class="textarea-style input-padding">
            </textarea>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.availableServices") }}
          </div>
          <div class="input-group mb-3">
            <wj-list-box class="input-style selection-style" :itemsSource="availableServices"
              :checkedMemberPath="'selected'" :selectedValuePath="'externalId'" :displayMemberPath="'description'"
              :checkedItems="checkedServices" :isRequired="false" :checkedItemsChanged="onCheckedItemChanged">
            </wj-list-box>
          </div>
        </div>
        <div class="col-md-4">
          <div class="label">
            {{ $t("pages.Client.assignedServices") }}
          </div>
          <div class="input-group mb-3">
            <wj-list-box @change="toggleChange = !toggleChange" class="input-style selection-style"
              :itemsSource="checkedServices" :selectedValuePath="'externalId'" :displayMemberPath="'description'"
              :isRequired="false">
            </wj-list-box>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="text-align: right">
          <a class="dm-a-default btn-red" @click="goToHome()">
            <i class="scf-cancel"></i> {{ $t("common.cancel") }}</a>
          <button v-if="pageFrom == 'create'" class="dm-a-default btn-green" type="submit">
            <i class="scf-validate"></i> {{ $t("common.save") }}
          </button>
          <button v-else-if="pageFrom == 'edit'" class="dm-a-default btn-green" type="submit">
            <i class="scf-validate"></i> {{ $t("pages.Client.editBtn") }}
          </button>
        </div>
        
        <modal :show="showErrorsModal" @update:show="showErrorsModal = false" :type="'notif'" :icon="'scf-Incident'"
          :title="errorTitle" :content="htmlErrors" :closeBtn="true" :actions="[{ ok: 'OK' }]">
        </modal>

        <modal :show="showQuitModal" @update:show="setQuitModal" :type="'notif'" :icon="'scf-Incident'"
          :title="quitModalTitle" :content="quitModalContent" :closeBtn="true"
          :actions="[{ cancel: cancelBtn }, { quit: quitWithoutSavingBtn }]">
        </modal>

        <modal :show="showSaveClientModal" @update:show="setSaveClientModal" :type="'notif'" :icon="'scf-Incident'"
          :title="checkKeycloackAndCode" :content="checkKeycloackAndCodeModalContent" :closeBtn="true"
          :actions="[{ cancel: cancelBtn }, { save: saveBtn }]">
        </modal>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import ClientService from "../services/ClientService";
//import Swal from "sweetalert2";
//import Configs from "../../configs";
import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.vue2.core";
import {
  WjComboBox,
  WjAutoComplete,
  WjListBox,
  WjMultiSelect,
} from "@grapecity/wijmo.vue2.input";
import formModalZones from "../components/FormModalZones.vue";
import formModalOrganizations from "../components/FormModalOrganizations.vue";
import Modal from "@supervision/vue-components/components/Modal";

export default defineComponent({
  name: "ClientForm",
  inject: ["accessToken", "updatePageChangeState", "okToChangePage"],
  components: {
    WjComboBox,
    WjListBox,
    formModalZones,
    formModalOrganizations,
    Modal,
    WjAutoComplete,
    WjMultiSelect,
  },
computed: {
  culture() {
    return this.$i18n.locale;
  },

  translatedCultures() {
    if (!this.cultures || this.cultures.length === 0) {
      return [];
    }

    return this.cultures.map(culture => {
      const translationKey = `pages.Client.cultures.${culture.code}`;
      return {
        ...culture,
        translatedDescription: this.$t(translationKey) || culture.description
      };
    });
  },

//  translatedStatus() {
//   return this.status.map(statusItem => ({
//     ...statusItem,
//     translatedLabel: this.$t(`pages.Client.statusEnum.${statusItem.id.toUpperCase()}`) || statusItem.label
//   }));
// },
translatedStatus() {
  return this.status.map(statusItem => {
    const key = statusItem.id?.toUpperCase?.(); // safe check
    console.log("🚀 ~ translatedStatus ~ key:", key);
    const translation = this.$t(`pages.Client.statusEnum.${key}`);
    return {
      ...statusItem,
      translatedLabel: translation !== `pages.Client.statusEnum.${key}`
        ? translation
        : statusItem.label // fallback si la trad n'existe pas
    };
  });
}
,

translatedRgpd() {
  return this.rgpd.map(item => ({
    ...item,
    translatedLabel: this.$t(`pages.Client.rgpdValues.${item.id}`)
  }));
},


  translatedApiCurves() {
    if (!this.apiCurves || this.apiCurves.length === 0) {
      return [];
    }

    return this.apiCurves.map(curve => ({
      ...curve,
      translatedDescription: curve.description
    }));
  }
}
,
  watch: {
    toggleChange() {
      if (this.$props.pageFrom == "details") return;
      this.okToChangePage[this.$props.pageFrom] =
        this.clientPropVersion.replace(/\s/g, "") ==
        JSON.stringify(this.formData).replace(/\s/g, "");
      this.updatePageChangeState(this.okToChangePage);
    },
    currentScope(newVal) {
      if (newVal) {
        this.clientService = new ClientService(this.$jwt.token, newVal);
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.clientService = new ClientService(newVal, this.currentScope);
      }
    },
    "formData.name": function (newVal) {
      if (this.pageFrom == "create") {
        this.formData.externalId = newVal;
        this.formData.keycloak = newVal;
      }
    },

    "formData.externalId": function (newVal) {
      newVal = newVal.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      newVal = newVal.replace(/\s/g, "_");
      newVal = this.removeSpecialChars(newVal);
      this.formData.externalId = newVal.toUpperCase().substring(0, 30);
    },

    "formData.keycloak": function (newVal) {
      newVal = newVal.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      newVal = newVal.replace(/\s/g, "_");
      newVal = this.removeSpecialChars(newVal);
      this.formData.keycloak = newVal.toUpperCase().substring(0, 30);
    },
  },
  data() {
    return {
      toggleChange: false,
      formData: {
        name: "",
        externalId: "",
        keycloak: "",
        timezone: "",
        culture: "",
        status: "",
        gdpr: "",
        apiCurve: "",
        daysNumber: "",
        levelsNumber: "",
        services: [],
        levels: [],
        configuration: {},
        hierarchyContent: []
      },
      clientPropVersion: null,
      clientService: new ClientService(this.$jwt.token, this.$jwt.scope),
      currentScope: this.$jwt.scope,
      checkedServices: [],
      showModal: false,
      showModalOrg: false,
      zoneModalTitle: computed(() => this.$t("pages.Client.enteringZones")),
      FormErrors: {},
      htmlErrors: "",
      showErrorsModal: false,

      saveClicked: false,
      showQuitModal: false,
      saveClickedDone: false,
      quitModalContent: computed(() => this.$t("pages.Client.quitNewClient")),
      quitModalTitle: computed(() => this.$t("pages.Client.addClient")),
      cancelBtn: computed(() => this.$t("common.cancel")),
      saveBtn: computed(() => this.$t("common.save")),
      quitWithoutSavingBtn: computed(() =>
        this.$t("pages.Client.quitWithoutSaving")
      ),
      errorTitle: computed(() => this.$t("pages.Client.errorTitle")),
      notClickable: {
        cursor: "default",
        color: "#ccc",
      },
      showSaveClientModal: false,
      checkKeycloackAndCode: computed(() =>
        this.$t("pages.Client.checkKeycloackAndCodeTitle")
      ),
      checkKeycloackAndCodeModalContent: computed(() =>
        this.$t("pages.Client.checkKeycloackAndCodeModalContent")
      ),
    };
  },
  props: {
    timeZones: {
      type: Array,
      required: true,
      default: () => [],
    },
    cultures: {
      type: Array,
      required: true,
      default: () => [],
    },
    status: {
      type: Array,
      required: true,
      default: () => [],
    },
    businessActs: {
      type: Array,
      required: true,
      default: () => [],
    },
    rgpd: {
      type: Array,
      required: true,
      default: () => [],
    },
    apiCurves: {
      type: Array,
      required: true,
      default: () => [],
    },
    availableServices: {
      type: Array,
      required: true,
      default: () => [],
    },
    client: {
      type: Object,
      required: false,
    },
    pageFrom: {
      type: String,
      required: false,
      default: () => "create",
    },
  },

  async mounted() {
    await this.intializeForm();
  },

  methods: {
    translationExists(key) {
      return typeof this.$tm(key) === "string";
    },
    async intializeForm() {
      if (this.client) {
        this.formData = JSON.parse(JSON.stringify(this.client));
        console.log("🚀 ~ #############:", this.formData);
        this.formData.configuration = JSON.parse(
          this.client.clientConfiguration
        );
        this.formData.gdpr = this.client.gdpr.toString();
        var service = null;
        var servicesResult = [];
        for (let index in this.client.services) {
          service = this.clientService.getService(
            this.availableServices,
            this.client.services[index]
          );
          servicesResult.push(service);
        }
        this.checkedServices = servicesResult;
      }
      this.clientPropVersion = JSON.stringify(this.formData);
      console.log(
        "🚀 ~ intializeForm ~ clientPropVersion:",
        this.clientPropVersion
      );
      if (this.client && this.client.externalId) {

        this.formData.hierarchyContent = await this.clientService.getHierarchyByClient(this.client.externalId);

        console.log("🚀 ~ intializeForm ~ this.formData.hierarchyContent:", this.formData.hierarchyContent);
      }
      //hierarchyContent
    },
    isSelectedItem(formData, ba) {
      if (
        !formData ||
        !formData.configuration ||
        !formData.configuration.ForbiddenBusinessActs
      )
        return false;
      return ba.businessAct.every((v) =>
        formData?.configuration?.ForbiddenBusinessActs?.includes(v)
      );
    },
    onForbiddenBusinessActChanged(s) {
      this.toggleChange = !this.toggleChange;
      let selectedValues = s.checkedItems.map((v) => v.businessAct);
      let businessActsSum = selectedValues.flat(1);
      const forbiddenBusinessActs = { ForbiddenBusinessActs: businessActsSum };
      this.formData.clientConfiguration = JSON.stringify(forbiddenBusinessActs);
      this.formData.configuration = forbiddenBusinessActs;
    },
    handleSubmit() {

      console.log("submit formData", this.formData);
      this.saveClicked = true;
      var htmlErrors = this.$t("pages.Client.missingFields");
      this.FormErrors = {};
      var hasError = false;

      if (this.formData.name == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.name");
        this.FormErrors.name = true;
        hasError = true;
      }
      if (
        this.formData.externalId == "" ||
        this.formData.externalId.length > 12
      ) {
        htmlErrors += "<br>- " + this.$t("pages.Client.code");
        this.FormErrors.externalId = true;
        hasError = true;
      }
      if (this.formData.keycloak == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.keycloak");
        this.FormErrors.keycloak = true;
        hasError = true;
      }
      if (this.formData.status == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.status");
        this.FormErrors.status = true;
        hasError = true;
      }
      if (this.formData.timezone == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.timeZone");
        this.FormErrors.timeZone = true;
        hasError = true;
      }
      if (this.formData.culture == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.culture");
        this.FormErrors.culture = true;
        hasError = true;
      }
      if (this.formData.gdpr == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.rgpd");
        this.FormErrors.gdpr = true;
        hasError = true;
      }
      if (this.formData.apiCurve == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.apiCurve");
        this.FormErrors.apiCurve = true;
        hasError = true;
      }
      if (this.formData.levelsNumber == "") {
        htmlErrors += "<br>- " + this.$t("pages.Client.levelsNumber");
        this.FormErrors.levelsNumber = true;
        hasError = true;
      }
      // if (this.formData.levels.length != this.formData.levelsNumber) {
      //   htmlErrors += "<br>- " + this.$t("pages.Client.levels");
      //   this.FormErrors.levelsNumber = true;
      //   hasError = true;
      // }
      const filledLevels = this.formData.levels.filter(val => this.isValid(val));

      if (filledLevels.length !== this.formData.levelsNumber) {
        htmlErrors += "<br>- " + this.$t("pages.Client.EmptyLevel");
        //this.FormErrors.levelsNumber = true;
        hasError = true;
      }

      if (this.formData.status != 'Inactive') {
        if (
          (!Array.isArray(this.formData.hierarchyContent) || this.formData.hierarchyContent.length === 0) &&
          this.formData.levelsNumber > 1
        ) {

          htmlErrors += "<br>- " + this.$t("pages.Client.TereIsNoConfiguration");
          //this.FormErrors.levelsNumber = true;
          hasError = true;
        }

        if (
          (Array.isArray(this.formData.hierarchyContent) && this.formData.hierarchyContent.length > 0)
        ) {

          if (this.formData.hierarchyContent[0].levelsNumber != this.formData.levelsNumber) {
            htmlErrors += "<br>- " + this.$t("pages.Client.LoadNewConfiguration");
            hasError = true;
          }

        }
      }


      if (hasError) {
        this.htmlErrors = htmlErrors;
        this.showErrorsModal = true;
      } else {
        this.formData.configuration =
          this.formData.clientConfiguration != null
            ? JSON.parse(this.formData.clientConfiguration)
            : {};
        if (this.pageFrom == "edit") {
          this.$emit("save", { ...this.formData });
          //this.$emit("goToList");
        } else {
          this.showSaveClientModal = true;
        }
      }
    },

    removeSpecialChars(str) {
      return str
        .replace(/(?!\w|\s)./g, "")
        .replace(/\s+/g, " ")
        .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2");
    },

    onCheckedItemChanged: function (listBox) {
      this.checkedServices = listBox.checkedItems;
      var servicesResult = [];
      for (let index in this.checkedServices) {
        servicesResult.push(this.checkedServices[index].externalId);
      }
      this.formData.services = servicesResult;
      this.toggleChange = !this.toggleChange;
    },
    isValid(value) {
      return value !== undefined && value !== null && value !== '';
    },
    isNotEmpty(value) {
      return value !== '';
    },
    updateModal(result) {
      console.log("🚀 ~ updateModal ~ result:", result);
      //let missedLabelForLevels = [] ;
      this.formData.levels = [];

      var levels = [];
      var i = 1;
      for (let index in result) {
        if (i <= this.formData.levelsNumber)
          levels.push(result[index]);

        i++;


      }

      //   if (missedLabelForLevels.length > 0) {

      //       // this.htmMissingLabelFieldlErrors += "<br>- " + "Please put label for levels: " + missedLabelForLevels.join(", ");
      //       //  this.FormErrors.levelsNumber = true;
      //     //alert("Please put label for levels: " + missedLabelForLevels.join(", "));
      // //     Swal.fire({

      // //   text: "Please put label for levels: " + missedLabelForLevels.join(", "),
      // //   icon: "error"
      // // });
      // //      this.showModal = true;
      //   }else{
      //  this.showModal = false;
      //       this.toggleChange = !this.toggleChange;
      //   }


      this.showModal = false;
      this.toggleChange = !this.toggleChange;
      this.formData.levels = levels;

      // if(this.formData.levels.length > this.formData.levelsNumber)


      console.log("formData is ", this.formData);

    },
    UpdateHirarchicalConfig(result) {

      console.log("🚀 clientForm receive from child component (FormModalOrg)", result?.[0]);

      if (Array.isArray(result) && result.length > 0 && result[0]) {
        this.formData.hirarchicalConfiguration = JSON.parse(JSON.stringify(result[0]));
        this.formData.hierarchyContent = JSON.parse(JSON.stringify([result[0]]));
      } else {
        this.formData.hirarchicalConfiguration = [];
        this.formData.hierarchyContent = [];
      }

      this.showModalOrg = false;
      this.toggleChange = !this.toggleChange;
      console.log(this.formData);
    },

    goToHome() {
      if (!this.saveClickedDone) {
        this.showQuitModal = true;
      } else {
        this.$emit("goToList");
      }
    },

    setQuitModal: function (result) {
      this.showQuitModal = false;
      if (result == "quit") {
        this.intializeForm();
        this.okToChangePage.forceOk();
        this.updatePageChangeState(this.okToChangePage);
        this.$emit("goToList");
      }
    },

    setSaveClientModal: function (result) {
      this.showSaveClientModal = false;
      if (result == "save") {
        this.saveClickedDone = true;
        this.$emit("save", { ...this.formData });
        //this.$emit("goToList");
      }
    },
  },
});
</script>

<style scoped lang="scss">
@import "../../node_modules/@grapecity/wijmo.styles/wijmo.css";

.disabled {
  color: #bbb !important;
}
</style>

<style scoped src="../assets/css/client.css"></style>
